import { render } from "./stage9.vue?vue&type=template&id=73cd5135&scoped=true"
import script from "./stage9.vue?vue&type=script&lang=js"
export * from "./stage9.vue?vue&type=script&lang=js"

import "./stage9.vue?vue&type=style&index=0&id=73cd5135&scoped=true&lang=css"

import exportComponent from "/home/runner/work/origins-userdash-v2/origins-userdash-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cd5135"]])

export default __exports__